import api from './api';
import { User, ApiResponse } from '../types';

interface LoginData {
  email: string;
  password: string;
}

interface RegisterData {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  phone: string;
  company_name?: string;
  language?: string;
  referral_code?: string;
  plan_id?: string;
  billing_cycle?: 'monthly' | 'yearly';
}

interface AuthResponse {
  user: User;
  token: string;
  checkoutUrl?: string | null;
}

export const authService = {
  async login(data: LoginData): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/login', data);
    return response.data;
  },

  async register(data: RegisterData): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  async getProfile(): Promise<ApiResponse<User>> {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  async updateProfile(data: Partial<User>): Promise<ApiResponse<User>> {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  async changePassword(data: { current_password: string; new_password: string }): Promise<ApiResponse<void>> {
    const response = await api.put('/auth/change-password', data);
    return response.data;
  },

  async forgotPassword(email: string): Promise<ApiResponse<void>> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token: string, password: string): Promise<ApiResponse<void>> {
    const response = await api.post(`/auth/reset-password/${token}`, { password });
    return response.data;
  },

  async verifyEmail(token: string): Promise<ApiResponse<void>> {
    const response = await api.get(`/auth/verify-email/${token}`);
    return response.data;
  },

  async updateNotificationSettings(settings: {
    email_reports: boolean;
    email_alerts: boolean;
    email_tips: boolean;
    push_notifications: boolean;
  }): Promise<ApiResponse<void>> {
    const response = await api.put('/auth/notification-settings', settings);
    return response.data;
  }
};
